module.exports = __webpack_public_path__ + "img/Nemzeti_Bajnokok_Program.c7cc1f88.png";